/**
 * @description 全局变量
 */
import * as _ from '@antv/util';
// @ts-ignore
import * as pkg from '../package.json';
import { getTheme } from './theme';
var Global = {
    version: pkg.version,
    renderer: 'canvas',
    width: 640,
    height: 480,
    pixelRatio: null,
    animate: true,
    widthRatio: {
        // 宽度所占的分类的比例
        column: 1 / 2,
        rose: 0.9999999,
        multiplePie: 1 / 1.3,
    },
    theme: getTheme('default'),
    setTheme: function (type) {
        var newTheme = {};
        if (_.isObject(type)) {
            newTheme = type;
        }
        else if (getTheme(type)) {
            newTheme = getTheme(type);
        }
        else {
            newTheme = getTheme('default');
        }
        // @ts-ignore
        _.deepMix(Global.theme, newTheme);
    },
};
export default Global;
export var setTheme = Global.setTheme;
export var version = Global.version;
//# sourceMappingURL=global.js.map